if (!customElements.get('dharin-mobile-navigation')) {
  customElements.define('dharin-mobile-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.launch = this.querySelector('.dharin-nav-launch');
      this.scrollArea = this.querySelector('.dharin-nav-scroll');
      this.launch.addEventListener('click', () => {
        this.showPanel('root');
        this.dialog.showModal();
        this.launch.setAttribute('aria-expanded', 'true');
        this.querySelector('[data-nav-close]').focus();
      });
      this.querySelector('[data-nav-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        this.launch.setAttribute('aria-expanded', 'false');
        this.showPanel('root');
        this.launch.focus();
      });
      this.querySelectorAll('[data-nav-to]').forEach(button => {
        button.addEventListener('click', () => {
          this.currentTrigger = button;
          this.rootScroll = this.scrollArea.scrollTop;
          this.showPanel(button.dataset.navTo);
          this.querySelector('[data-nav-panel]:not([hidden]) [data-nav-back]').focus();
        });
      });
      this.querySelectorAll('[data-nav-back]').forEach(button => {
        button.addEventListener('click', () => {
          this.showPanel('root');
          this.currentTrigger?.focus({preventScroll: true});
          this.scrollArea.scrollTop = this.rootScroll || 0;
        });
      });
      this.media = window.matchMedia('(max-width: 1069px)');
      this.onResize = () => { if (!this.media.matches && this.dialog.open) this.dialog.close(); };
      this.media.addEventListener('change', this.onResize);
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.onResize); }
    showPanel(name) {
      this.querySelectorAll('[data-nav-panel]').forEach(panel => { panel.hidden = panel.dataset.navPanel !== name; });
      this.querySelectorAll('[data-nav-to]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.navTo === name)));
      this.scrollArea.scrollTop = 0;
    }
  });
}
